/* eslint-disable */
export default {
  status: 'Status',
  acceptQueueCalls: 'Warteschlangenanrufe annehmen',
  callQueueDisabledReason:
    'Diese Einstellung wird von Ihrem Unternehmensadministrator verwaltet.',
  callQueueManagement: 'Warteschlangen verwalten',
} as const;

// @key: @#@"status"@#@ @source: @#@"Status"@#@
// @key: @#@"acceptQueueCalls"@#@ @source: @#@"Accept call queue calls"@#@
// @key: @#@"callQueueDisabledReason"@#@ @source: @#@"This setting is managed by your company administrator."@#@
// @key: @#@"callQueueManagement"@#@ @source: @#@"Manage queues"@#@
